<template>
  <m-fab
    class="fab"
    :icon="icon"
    v-bind="$attrs"
    v-on="$listeners">
    <m-icon
      v-if="icon"
      slot="icon"
      :icon="icon" />
  </m-fab>
</template>

<script>
import Vue from 'vue'
import Fab from 'material-components-vue/dist/fab'
import Icon from 'material-components-vue/dist/icon'
Vue.use(Fab)
Vue.use(Icon)

export default {
  props: {
    icon: { default: '', required: false, type: String }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../universal/vars.scss';
  @import "material-components-vue/dist/fab/styles";
  .fab, .mdc-fab:hover, .mdc-fab:focus {
    box-shadow: none;
  }
  .purple-fab {
    background: $chip-purple-bg;

    .material-icons {
      color: $chip-purple-icon;
    }
  }
  .theme-secondary {
    background: $mdc-theme-secondary--50;
    .material-icons {
      color: $mdc-theme-secondary;
    }
  }
  .theme-primary {
    background: $mdc-theme-primary--100;
    .material-icons {
      color: $mdc-theme-primary--700;
    }
  }
  .orange-fab {
    background: $chip-orange-bg;
    .material-icons {
      color: $chip-orange-icon;
    }
  }
  .mdc-fab[disabled=disabled] {
    cursor: initial;
  }
</style>
